import apiService from './api';

export interface XlsxDocument {
  id: number;
  document_name: string;
  document_details: string;
  document_date: string;
  file_url: string;
  user_id: number;
  company_id: number;
  uploaded_by_name: string;
  created_at: string;
  updated_at: string;
}

export interface XlsxUploadResponse {
  status: boolean;
  message: string;
  data: XlsxDocument[];
  xlsxFile: {
    originalName: string;
    filename: string;
    size: number;
    mimetype: string;
    path: string;
    url: string;
  };
  totalRecords: number;
}

export interface PdfUploadResponse {
  status: boolean;
  message: string;
  data: {
    originalName: string;
    filename: string;
    size: number;
    mimetype: string;
    path: string;
    url: string;
  }[];
  errors: {
    file: string;
    error: string;
  }[];
  totalUploaded: number;
  totalErrors: number;
}

export interface SinglePdfUploadResponse {
  status: boolean;
  message: string;
  data: {
    originalName: string;
    filename: string;
    size: number;
    mimetype: string;
    path: string;
    url: string;
  };
}

export interface XlsxDocumentCount {
  total_count: number;
}


class XlsxDocumentService {
  async uploadXlsxDocument(formData: FormData): Promise<XlsxUploadResponse> {
    const response = await apiService.post<XlsxUploadResponse>('/xlsx-documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async uploadPdfDocument(formData: FormData): Promise<SinglePdfUploadResponse> {
    const response = await apiService.post<SinglePdfUploadResponse>('/xlsx-documents/upload-pdf', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async uploadMultiplePdfDocuments(formData: FormData): Promise<PdfUploadResponse> {
    const response = await apiService.post<PdfUploadResponse>('/xlsx-documents/upload-pdfs', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async getXlsxDocuments(searchTerm?: string): Promise<XlsxDocument[]> {
    const params = searchTerm ? { search: searchTerm } : {};
    const response = await apiService.get<XlsxDocument[]>('/xlsx-documents', { params });
    return response.data;
  }
  
  async getXlsxDocumentsDuplicate(): Promise<XlsxDocument[]> {
    const response = await apiService.get<XlsxDocument[]>('/xlsx-documents/xlsx/duplicate');
    return response.data;
  }

  async getXlsxDocumentsCount(): Promise<XlsxDocumentCount> {
    const response = await apiService.get<XlsxDocumentCount>('/xlsx-documents/count');
    console.log("response.data32113::::::::", response.data);
    return response.data;
  }

  async deleteXlsxDocument(id: number): Promise<void> {
    await apiService.delete(`/xlsx-documents/${id}`);
  }
}

export const xlsxDocumentService = new XlsxDocumentService();
export default xlsxDocumentService; 
